import { render } from "./Contatos.vue?vue&type=template&id=a4895926&scoped=true"
import script from "./Contatos.vue?vue&type=script&lang=js"
export * from "./Contatos.vue?vue&type=script&lang=js"

import "./Contatos.vue?vue&type=style&index=0&id=a4895926&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4895926"]])

export default __exports__